<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" top="2vh" @close="close">
    <!-- 所属用户 -->
    <el-form v-if="dialogFormVisible" ref="form" :model="form" :rules="rules" label-width="95px">
      <!-- 产品图片 -->
      <el-form-item label="已采购图片">
        <uploadFile :limit="1" :img-list-string="form.purchase_pic" @fileChange="uploadChange($event, 'pic')" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  buyPurchasePic,
  memberListAll,
  orderUpdate,
  ordergetEnableLocation,
  orderGetAllStorageLocation,
  Index_country_list,
  buyDetail
} from '@/api/xgcApi'
import {
  getUploadUrl
} from '@/config'
import uploadFile from '@/components/uploadFile'
import CitySelection from '@/components/CitySelection'
import {
  goodsAdd,
  index_city
} from '../../../api/xgcApi'
import {
  number
} from 'echarts'

export default {
  name: 'UserManagementEdit',
  components: {
    uploadFile,
    CitySelection,
  },
  computed: {
    dialogWidth() {
      return window.innerWidth < 768 ? '99vw' : '600px'
    }
  },
  data() {
    return {
      order_row: '',//选中包裹详情
      countryList: [],
      props: {
        lazy: true,
        lazyLoad: this.getcityList,
      },
      visible: false,
      loading: false,


      form: {
        id: '',
        purchase_pic: '',
      },
      dialogFormVisible: false,
      rules: {
      },
      title: '',
      isShowCode: false,
    }
  },

  created() { },
  mounted() {
  },
  methods: {
    // 调起移动端键盘
    clear(async) {
      this.$nextTick(() => {
        if (!async) {
          // ios 手机有延迟问题
          setTimeout(() => {
            const {
              select
            } = this.$refs
            const input = select.$el.querySelector('.el-input__inner')
            input.removeAttribute('readonly')
          }, 200)
        }
      })
    },
    // // 解决ios移动端选择双击问题
    // recordTouchStart(event) {
    //   const u = navigator.userAgent
    //   const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    //   if (isiOS && this._isMobile()) {
    //     event.visible = true //only work in iOS
    //   }
    // },
    // _isMobile() {
    //   return navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   )
    // },

    // 上传图片
    uploadChange(e) {
      var strurl = e.join(',')
      strurl = strurl.replace('\\\\', '\/\/')
      strurl = strurl.replace('\\', '\/')
      strurl = strurl.replace('\\', '\/')
      this.form.purchase_pic = strurl
    },
    // 初始化请求数据
    // country，type  1=韩国，2=日本
    async showEdit(row) {
      console.log(row, 'id')
      this.form.id = row.id
      this.title = '添加'
      this.dialogFormVisible = true
           const { data } = await buyDetail({ id: row.id })
           console.log(data,'789')

if(data.purchase_pic){
  this.form.purchase_pic =  data.purchase_pic
// const pic = data.purchase_pic.split(',')
//           this.form.purchase_pic = pic
}


// console.log(this.form.purchase_pic,'9999')


    },


    // 关闭弹窗
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },

    // 提交修改//修改传ID  添加不传ID
   async save() {
      const {
        data,
        msg
      } = await buyPurchasePic(this.form)
      this.$baseMessage(msg, 'success')
      this.$emit('fetch-data')
      this.close()
    },
  },
}
</script>
<style scoped lang="scss">
:deep .el-dialog__body {
  height: 70vh;
  overflow: hidden;
  overflow-y: scroll;
}

:deep .el-input--small .el-input__inner {}

// :deep .el-scrollbar .el-scrollbar__bar {
//   opacity: 1 !important;
// }
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
